import React, { FC, useCallback } from 'react';
import stringUtils from '../../utils/string';
import useCollapseText from '../../hooks/useCollapseText';
import { useTranslationAPI } from '../../modules/translations';
import classes from './styles/index.module.scss';
import { codes } from '../../data/translations';

type TextCollapserProps = {
	value: string;
	length?: number;
	stopPropagation?: boolean;
};

export const TextCollapser: FC<React.PropsWithChildren<TextCollapserProps>> = ({
	value = '',
	length = 160,
	stopPropagation = false,
}) => {
	const { translate } = useTranslationAPI();
	const hasValue = !stringUtils.isNullOrEmpty(value);

	const { isCollapsed, collapseText, setIsCollapsed, hasCollapseMode } = useCollapseText(value, length);

	const handleCollapseButtonClick = useCallback(
		(e) => {
			if (stopPropagation) {
				e.stopPropagation();
			}
			setIsCollapsed((prevIsCollapsed) => !prevIsCollapsed);
		},
		[setIsCollapsed, stopPropagation],
	);

	return (
		<div className={classes.textCollapser}>
			{hasValue && collapseText}

			{hasCollapseMode && (
				<span
					className={classes.button}
					onClick={handleCollapseButtonClick}
				>
					{isCollapsed ? translate(codes.more) : translate(codes.less)}
				</span>
			)}
		</div>
	);
};
